import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NbComponentStatus } from '@nebular/theme';
import { RepairTaskDetailDto } from '@artemis-software/wr-api';
import StatusEnum = RepairTaskDetailDto.StatusEnum;

export const REPAIR_TASK_STATUS_COLORS: Record<StatusEnum, NbComponentStatus> = {
  DRAFT: 'basic',
  TODO: 'info',
  IN_PROGRESS: 'warning',
  FINISHED: 'success',
  DECLINED: 'danger',
};

@Component({
  standalone: false,
  selector: 'wr-repair-task-status-text',
  templateUrl: './repair-task-status-text.component.html',
  styleUrls: ['./repair-task-status-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RepairTaskStatusTextComponent {
  readonly status = input<StatusEnum | null | undefined>();

  readonly color = computed(() => {
    const status = this.status();
    return status ? REPAIR_TASK_STATUS_COLORS[status] : undefined;
  });
}
